export default __webpack_public_path__ + "0c8c84815c3b0a6b585e085074481529.svg";